// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-caption[data-v-9a811bac]{color:#3d3d3d;font-size:18px;width:auto;padding:3px;padding-left:0;font-weight:bold}", ""]);
// Exports
module.exports = exports;
